import { AppRuleActions, AppRuleNames } from "@Front/Api/Entities/rule";
import { Routes } from "@Front/Config/Routes";
import { TagIcon, UsersIcon } from "@heroicons/react/24/outline";
import { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";

const MENU_LABELS = COMMON_UI_I18N.navigationMenu;

const createSuperAdminItem = (icon: React.ReactNode, text: string, link: string, routesActive: string[]): IItem => ({
	icon,
	text,
	link,
	routesActive,
	rules: [
		{
			action: AppRuleActions.update,
			name: AppRuleNames.offices,
		},
	],
});

export function getSuperAdminItems(): IItem[] {
	return [
		createSuperAdminItem(<UsersIcon />, MENU_LABELS.superAdmin.usersManagement, Routes.pages.Users.base, [
			Routes.pages.Users.UsersInformations,
			Routes.pages.Users.base,
		]),
		createSuperAdminItem(<UsersIcon />, MENU_LABELS.superAdmin.officesManagement, Routes.pages.Offices.base, [
			Routes.pages.Offices.OfficesInformations,
			Routes.pages.Offices.base,
		]),
		createSuperAdminItem(<UsersIcon />, MENU_LABELS.superAdmin.dashboard, Routes.pages.Admin.Dashboard, [Routes.pages.Admin.Dashboard]),
		createSuperAdminItem(<UsersIcon />, MENU_LABELS.superAdmin.officeSeats, Routes.pages.Admin.OfficeSeats, [Routes.pages.Admin.OfficeSeats]),
		createSuperAdminItem(<TagIcon />, MENU_LABELS.superAdmin.subscriptionPlans, Routes.pages.SuperAdmin.SubscriptionPlans, [
			Routes.pages.SuperAdmin.SubscriptionPlans,
			Routes.pages.SuperAdmin.SubscriptionPlansCreate,
		]),
	];
}
